const urlFor = (endpoint) => {
 return `https://frengly.com/rest/v1/${endpoint}`;
};

export default urlFor;